import { render, staticRenderFns } from "./DueDateCalendar.vue?vue&type=template&id=438fa5a3&scoped=true&"
import script from "./DueDateCalendar.vue?vue&type=script&lang=js&"
export * from "./DueDateCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DueDateCalendar.vue?vue&type=style&index=0&id=438fa5a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fa5a3",
  null
  
)

export default component.exports